import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../util/apiUtils';

export const useOrganizationConfig = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['organizationConfig'],
    queryFn: async () => {
      const result = await apiRequest("get", `organization/config`, {
        isGuest: true
      });
      
      if (result.status === 200 && result.data) {
        return {
          _id:result.data?.data?._id,
          slug: result.data?.data?.slug || 'bistro',
          name: result.data?.data?.name || 'Bistro',
          logo: result.data?.data?.logo?.url,
          coverImage: result.data?.data?.coverImage?.url,
          theme: result.data?.data?.theme,
          isActive: !result.data?.data?.isSuspended,
          contactEmail: result.data?.data?.contactEmail,
          contactPhone: result.data?.data?.contactPhone,
          website: result.data?.data?.website,
          description: result.data?.data?.description
        };
      }
      
      // Fallback
      return {
        slug: 'bistro',
        name: 'Bistro',
        isActive: true
      };
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });

  return {
    config: data,
    loading: isLoading,
    error
  };
};